/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AgentImpersonationStatusAdminUser from './AgentImpersonationStatusAdminUser';

/**
 * The AgentImpersonationStatus model module.
 * @module model/AgentImpersonationStatus
 * @version 1.0.0
 */
class AgentImpersonationStatus {
    /**
     * Constructs a new <code>AgentImpersonationStatus</code>.
     * @alias module:model/AgentImpersonationStatus
     */
    constructor() { 
        
        AgentImpersonationStatus.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentImpersonationStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentImpersonationStatus} obj Optional instance to populate.
     * @return {module:model/AgentImpersonationStatus} The populated <code>AgentImpersonationStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentImpersonationStatus();

            if (data.hasOwnProperty('active')) {
                obj['active'] = ApiClient.convertToType(data['active'], 'Boolean');
            }
            if (data.hasOwnProperty('admin_user')) {
                obj['admin_user'] = AgentImpersonationStatusAdminUser.constructFromObject(data['admin_user']);
            }
            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('started_at')) {
                obj['started_at'] = ApiClient.convertToType(data['started_at'], 'Date');
            }
            if (data.hasOwnProperty('expires_at')) {
                obj['expires_at'] = ApiClient.convertToType(data['expires_at'], 'Date');
            }
            if (data.hasOwnProperty('read_only')) {
                obj['read_only'] = ApiClient.convertToType(data['read_only'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentImpersonationStatus</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentImpersonationStatus</code>.
     */
    static validateJSON(data) {
        // validate the optional field `admin_user`
        if (data['admin_user']) { // data not null
          AgentImpersonationStatusAdminUser.validateJSON(data['admin_user']);
        }

        return true;
    }


}



/**
 * @member {Boolean} active
 */
AgentImpersonationStatus.prototype['active'] = undefined;

/**
 * @member {module:model/AgentImpersonationStatusAdminUser} admin_user
 */
AgentImpersonationStatus.prototype['admin_user'] = undefined;

/**
 * @member {Number} agent_id
 */
AgentImpersonationStatus.prototype['agent_id'] = undefined;

/**
 * @member {Date} started_at
 */
AgentImpersonationStatus.prototype['started_at'] = undefined;

/**
 * @member {Date} expires_at
 */
AgentImpersonationStatus.prototype['expires_at'] = undefined;

/**
 * 代理ログイン中のプランナーが提携終了後（アクセス遮断中）で、参照（GET / HEAD）のみ許可されている状態
 * @member {Boolean} read_only
 */
AgentImpersonationStatus.prototype['read_only'] = undefined;






export default AgentImpersonationStatus;

